import * as yup from "yup";

import { messagesConstants } from "@/constants";

export const setPasswordFormSetPasswordAuthFormSchema = yup.object({
    confirmPassword: yup.string().required(messagesConstants.inputsMsgs.password).oneOf(
        [yup.ref("password"), null],
        messagesConstants.inputsMsgs.notMatchingPassword,
    ),
    password: yup.string().required(messagesConstants.inputsMsgs.password),
});
